import React, {CSSProperties, useRef} from 'react'
import {v4 as uuidv4} from "uuid";
import {Text} from "atmosfair-ui"
import {useTranslation} from "react-i18next";
import useFocus from "../../hooks/use-focus";

interface SearchInputProps {
    label: string,
    placeholder: string,
    onChange: (query: string) => void,
    value?: string | null,
    inputStyle?: CSSProperties,
}

const SearchInput = ({
                         label,
                         placeholder,
                         onChange,
                         value,
                         inputStyle
                     }: SearchInputProps) => {
    const {t} = useTranslation()
    const ariaForId = useRef(`:search-input-aria-for-id-${uuidv4()}:`)
    const isInputFocused = useFocus(ariaForId.current)

    const _setLabelColor = () => {
        if (isInputFocused) return "primary"
        return "black"
    }

    return <>
        <Text
            color={_setLabelColor()}
            classes={"label-text-styles"}
            htmlFor={ariaForId.current}
            variant={"label"}>
            {label}
        </Text>
        <input
            value={value ?? undefined}
            className={"input-field"}
            style={{width: "100%", ...inputStyle}}
            id={ariaForId.current}
            placeholder={`${t(placeholder)} ...`}
            onChange={event => onChange(event.target.value)}
            type={"search"}/>
    </>
}

export default SearchInput